import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Enquiries from "./components/Enquiries";
import Calculator from "./components/Calculator";
import "./App.css";
import RegionSelector from "./components/RegionSelector";
import AppBar from "./components/AppBar";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ff6600",
      dark: "#ff6600"
    }
  },
  typography: { useNextVariants: true }
});

const activeRegions = {
  au: { active: true, spec: { existingPipeSize: "DN50" } },
  us: { active: true, spec: { existingPipeSize: '1½"(DN40)' } },
  ca: { active: true, spec: { existingPipeSize: '1½" (DN40)' } }
};

const App = ({ match }) => {
  let currentRegion = match.params.id;
  let isActiveRegion = activeRegions.hasOwnProperty(currentRegion);

  return (
    <div>
      <MuiThemeProvider theme={theme}>
        <AppBar region={currentRegion} />
        {isActiveRegion ? (
          <div className="App">
            <div className="intro" style={{ marginTop: "48px" }}>
              <Typography variant="body1" style={{ marginTop: "32px", marginBottom: "64px" }}>
                This Swivelpole™ Cost Comparison Calculator is designed to demonstrate the cost savings in converting
                non-lowering walkway mounted poles to lowering poles using the Safe Swivel™ Joint (SSJ). Savings are
                shown from installation through to total estimated savings over the lifecycle of a plant. Cost is based
                on the standard Safe Swivel™ Joint to suit {activeRegions[currentRegion].spec.existingPipeSize} pipe.
              </Typography>
            </div>
            <Calculator region={currentRegion} />
            <div
              style={{
                marginTop: "24px",
                padding: "48px",
                backgroundColor: "#f7f7f7",
                borderRadius: "10px"
              }}>
              <Enquiries region={currentRegion} />
            </div>
          </div>
        ) : (
          <RegionSelector />
        )}
      </MuiThemeProvider>
    </div>
  );
};

const AppRouter = () => (
  <Router>
    <Switch>
      <Route exact path="/savings" component={App} />
      <Route path="/savings/:id/" component={App} />
    </Switch>
  </Router>
);

export default AppRouter;
